<template>
    <div class="bg-white p-8 md:p-12 font-sans">
        <div class="p-8 sm:p-12 max-w-7xl mx-auto">

            <div class="grid grid-cols-1 lg:grid-cols-5 gap-x-8">

                <div class="lg:col-span-2 flex flex-col space-y-8 relative">

                    <div class="hidden lg:block">
                        <div class="absolute top-[28rem] -left-4">
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M16 0V32" stroke="#D1D5DB" stroke-width="1" />
                                <path d="M0 16H32" stroke="#D1D5DB" stroke-width="1" />
                            </svg>
                        </div>
                        <div class="absolute top-[48rem] -left-4">
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M16 0V32" stroke="#D1D5DB" stroke-width="1" />
                                <path d="M0 16H32" stroke="#D1D5DB" stroke-width="1" />
                            </svg>
                        </div>
                    </div>

                    <div class="space-y-4">
                        <h2 class="text-4xl lg:text-5xl font-extrabold text-orange-500 leading-tight">
                            Trabalho em <br>
                            <span
                            class="bg-orange-500 text-white rounded-lg px-3 py-1">conjunto</span>
                        </h2>
                        <div class="text-black space-y-4">
                            <p>A parceria entre OverX e empresas de food service começou com o objetivo de otimizar a
                                gestão de leads e a qualificação de oportunidades.</p>
                            <p>A implementação da OverX ajudou a superar desafios como a falta de integração entre
                                setores, gestão desorganizada de pedidos e ineficiência no atendimento ao cliente.</p>
                            <p>Com a centralização de todos os processos, a OverX implementou um sistema de gestão de
                                leads qualificados, desde a captura até a conversão. Isso permitiu que a base de dados
                                fosse segmentada e qualificada para tomadas de decisão mais rápidas e precisas.</p>
                            <p>Nos últimos meses, a OverX registrou um crescimento robusto nos resultados, refletindo a
                                eficiência do sistema implementado.</p>
                            <p>A OverX é ideal para grandes redes de restaurante, franquias de alimentação, chefs de
                                private food e dark kitchens que precisam escalar suas operações com controle,
                                inteligência e tecnologia que realmente acompanha o ritmo acelerado do negócio.</p>
                        </div>
                    </div>

                    <div class="bg-orange-500 text-white p-8 rounded-2xl">
                        <p class="text-7xl font-bold leading-none">1.166</p>
                        <p class="text-6xl font-bold text-white">7%</p>
                        <p class="mt-4 text-white">Aumento de 1.166,7% na taxa de conversão</p>
                    </div>
                    <br/>
                    <div
                        class="h-64 flex items-center justify-center bg-white/5 border border-dashed border-gray-700 rounded-lg text-gray-500">
                        <img src="@/assets/foto3.png" alt="Exemplo do componente OverX"
                            class="rounded-lg shadow-2xl shadow-orange-500/10">
                    </div>
                    <br/>
                    <br/>
                    <div class="bg-orange-500 text-white p-8 shape-custom">
                        <p class="text-7xl font-bold">12,5</p>
                        <p class="mt-4 text-base">O time de SDR precisou abordar 12,5 vezes mais leads para gerar leads
                            mais qualificados com a OverX, permitindo que os esforços de vendas fossem direcionados para
                            os leads mais relevantes e potenciais.</p>
                    </div>

                </div>

                <div class="lg:col-span-3 flex flex-col space-y-8 mt-8 lg:mt-0 relative">

                    <div class="hidden lg:block">
                        <div class="absolute -top-4 -left-4">
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M16 0V32" stroke="#D1D5DB" stroke-width="1" />
                                <path d="M0 16H32" stroke="#D1D5DB" stroke-width="1" />
                            </svg>
                        </div>
                        <div class="absolute top-[16.5rem] -left-4">
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M16 0V32" stroke="#D1D5DB" stroke-width="1" />
                                <path d="M0 16H32" stroke="#D1D5DB" stroke-width="1" />
                            </svg>
                        </div>
                        <div class="absolute top-[33rem] -left-4">
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M16 0V32" stroke="#D1D5DB" stroke-width="1" />
                                <path d="M0 16H32" stroke="#D1D5DB" stroke-width="1" />
                            </svg>
                        </div>
                    </div>

                    <div class="bg-orange-500 text-white p-8 shape-custom">
                        <p class="text-8xl font-bold">31,3%</p>
                        <p class="mt-2 text-lg">de crescimento na base total de leads</p>
                    </div>
                    <div
                        class="h-64 flex items-center justify-center rounded-lg text-gray-500">
                       <img src="@/assets/fundo1.png" alt="Exemplo do componente OverX"
                          class="rounded-lg shadow-2xl shadow-orange-500/10">
                    </div>
                    <div class="bg-orange-500 text-white p-8 shape-custom">
                        <p class="text-8xl font-bold">94%</p>
                        <p class="mt-2 text-lg">Aumento de 94% em leads engajados</p>
                    </div>

                    <div class="bg-black text-white p-8 rounded-2xl space-y-4 leading-relaxed flex-1">
                        <br/>
                        <br/>
                        <p>Em janeiro de 2025, os testes com o CRM da OverX começaram, com foco em uma base de leads
                            qualificada. A segmentação incluiu tanto leads que concluíram todas as etapas de nutrição,
                            quanto aqueles que converteram em um material mais de fundo de funil.</p>
                        <p>Para avaliar os impactos da mudança, trouxemos um comparativo dos últimos meses. Os números
                            tanto do processo antigo — onde toda a base era enviada para a tratativa de SDR — quanto os
                            novos testes com o CRM.</p>
                        <p>O CRM comparativo ajudou a entender os efeitos das tratativas com leads mais qualificados —
                            que em média, apesar de serem um aumento em 1.166,7% o time de SDR precisou abordar 12,5
                            vezes menos leads para gerar mais leads qualificados para a Agora.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script setup>
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;700;900&display=swap');
.font-sans {
    font-family: 'Sora', sans-serif;
}
.shape-custom {
    border-top-left-radius: 1.25rem;
    border-top-right-radius: 1.25rem;
    border-bottom-right-radius: 1.25rem;
    border-bottom-left-radius: 0.25rem;
}
</style>